import { render, staticRenderFns } from "./RepairsTable.vue?vue&type=template&id=e3e445b2&scoped=true&"
import script from "./RepairsTable.vue?vue&type=script&lang=ts&"
export * from "./RepairsTable.vue?vue&type=script&lang=ts&"
import style0 from "./RepairsTable.vue?vue&type=style&index=0&id=e3e445b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3e445b2",
  null
  
)

export default component.exports